import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { removeWorkOrderChangePrices } from '../WorkOrderChangeQueries';

export const useWorkOrderChangeDeletePrices = ({
    workOrderChangeId,
    priceIds,
    resetCheckedRows,
    refreshTable,
}: {
    workOrderChangeId: number;
    priceIds: any[];
    resetCheckedRows: () => void;
    refreshTable: () => void;
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            workOrderChangeId,
            priceIds,
        }),
        [priceIds, workOrderChangeId],
    );

    const [
        deletePriceWorkOrderChangeData,
        deletePriceWorkOrderChangeStatus,
        deletePriceWorkOrderChangeErr,
        deletePriceWorkOrderChangeRequest,
        deletePriceWorkOrderChangeSetData,
    ] = useRequest({
        requestId: 'deletePriceWorkOrderChange',
        query: removeWorkOrderChangePrices,
        withEffect: false,
    });

    const refreshData = useCallback(() => {
        refreshTable();
        resetCheckedRows();
    }, [refreshTable, resetCheckedRows]);

    const deletePriceWorkOrderChangeHandler = useCallback(() => {
        dispatch(deletePriceWorkOrderChangeRequest(variables));
    }, [deletePriceWorkOrderChangeRequest, dispatch, variables]);

    return {
        deleteData: deletePriceWorkOrderChangeData?.uerRemoveWorkOrderChangePrices,
        deleteStatus: deletePriceWorkOrderChangeStatus,
        deleteError: deletePriceWorkOrderChangeErr,
        deleteSetData: deletePriceWorkOrderChangeSetData,
        handleDelete: deletePriceWorkOrderChangeHandler,
        onSuccess: refreshData,
    };
};
